var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPrint({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75031 0.383179H13.2503C13.6573 0.383365 13.9913 0.731582 13.9915 1.16638V6.21716H14.0413C15.3229 6.21716 16.3663 7.31095 16.3665 8.66638V12.0004C16.3663 13.3558 15.3229 14.4496 14.0413 14.4496H2.95831C1.67673 14.4496 0.633285 13.3558 0.633118 12.0004V8.66638C0.633285 7.31095 1.67674 6.21716 2.95831 6.21716H3.00812V1.16638C3.00828 0.731467 3.34319 0.383179 3.75031 0.383179ZM2.95831 7.78357C2.4912 7.78357 2.11668 8.18111 2.11652 8.66638V12.0004C2.11668 12.4856 2.4912 12.8832 2.95831 12.8832H14.0413C14.5085 12.8832 14.8829 12.4856 14.8831 12.0004V8.66638C14.883 8.18111 14.5085 7.78357 14.0413 7.78357H13.9915V9.50037C13.9913 9.93518 13.6573 10.2834 13.2503 10.2836H3.75031C3.34318 10.2836 3.00828 9.9353 3.00812 9.50037V7.78357H2.95831ZM4.49152 8.71716H12.5081V1.94958H4.49152V8.71716ZM6.91632 6.21716H10.0833C10.4906 6.21716 10.8245 6.56528 10.8245 7.00037C10.8244 7.4353 10.4904 7.78357 10.0833 7.78357H6.91632C6.50935 7.78338 6.17528 7.43518 6.17511 7.00037C6.17511 6.5654 6.50925 6.21735 6.91632 6.21716ZM6.91632 3.71716H10.0833C10.4906 3.71716 10.8245 4.0653 10.8245 4.50037C10.8244 4.93528 10.4904 5.28357 10.0833 5.28357H6.91632C6.50935 5.28338 6.17528 4.93517 6.17511 4.50037C6.17511 4.06542 6.50925 3.71735 6.91632 3.71716Z",
    fill: "#222222",
    stroke: "white",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrint);
export default __webpack_public_path__ + "static/media/icon-print.c850fcce5f061683c69f0b487691a2ca.svg";
export { ForwardRef as ReactComponent };